var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{attrs:{"filterable":"","value":_vm.displayValue,"collapse-tags":"","props":{ value: 'label', label: 'label', multiple: _vm.multiple, emitPath: _vm.emitPath, checkStrictly: false },"options":_vm.options},on:{"input":_vm.handleChangeValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }